export default [
  {
    path: window.pathApp + '/',
    name: 'index',
    component: () => import('@/components/Index'),
    meta: {
      login: false,
      avisoCarrinho: false,
      title: "Home",
    }
  },
  {
    path: "*",
    redirect: window.pathApp + "/",
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/index.js